<!--<h1>{{IsShowDetail}}</h1>-->
<div *ngIf='!IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Education</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">


                  <div class="form-body">
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Institute Type</label>
                        <CodeTypeValue CodeType="INSTY" id="CurrentActorEducationInfoRequest.InstituteType"
                                       [(ngModel)]="CurrentActorEducationInfoRequest.InstituteType" SelectedValue=""
                                       name="CurrentActorEducationInfoRequest.InstituteType"></CodeTypeValue>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Course Study</label>
                        <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.CourseStudy"
                               [(ngModel)]="CurrentActorEducationInfoRequest.CourseStudy"
                               name="CurrentActorEducationInfoRequest.CourseStudy" placeholder="CourseStudy" required>
                      </div>
                    </div>
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Course Type</label>
                        <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.CourseType"
                               [(ngModel)]="CurrentActorEducationInfoRequest.CourseType" name="CurrentActorEducationInfoRequest.CourseType"
                               placeholder="CourseType">
                      </div>
                    </div>-->


                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Institute Name</label>
                        <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.InstituteName"
                               [(ngModel)]="CurrentActorEducationInfoRequest.InstituteName" name="CurrentActorEducationInfoRequest.InstituteName"
                               placeholder="InstituteName">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Location</label>
                        <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.Location"
                               [(ngModel)]="CurrentActorEducationInfoRequest.Location" name="CurrentActorEducationInfoRequest.Location" placeholder="Location">
                      </div>
                    </div>





                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput4">Start From</label>
                        <input type="date" class="form-control" id="CurrentActorEducationInfoRequest.StartFrom"
                               [(ngModel)]="CurrentActorEducationInfoRequest.StartFrom" name="CurrentActorEducationInfoRequest.StartFrom"
                               placeholder="StartFrom">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Completed At</label>
                        <input type="date" class="form-control" id="CurrentActorEducationInfoRequest.CompletedAt"
                               [(ngModel)]="CurrentActorEducationInfoRequest.CompletedAt" name="CurrentActorEducationInfoRequest.CompletedAt"
                               placeholder="CompletedAt" >
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Graduate</label>
                        <input type="checkbox" class="form-control" id="CurrentActorEducationInfoRequest.IsGraduate"
                               [(ngModel)]="CurrentActorEducationInfoRequest.IsGraduate" name="CurrentActorEducationInfoRequest.IsGraduate" placeholder="IsGraduate">
                      </div>
                    </div>
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Subjects</label>
                        <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.Subjects"
                               [(ngModel)]="CurrentActorEducationInfoRequest.Subjects" name="CurrentActorEducationInfoRequest.Subjects" placeholder="Subjects">
                      </div>
                    </div>-->

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Remarks</label>
                        <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.Remarks"
                               [(ngModel)]="CurrentActorEducationInfoRequest.Remarks" name="CurrentActorEducationInfoRequest.Remarks" placeholder="Remarks">
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="col-md-12">
                        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                      </div>
                    </div>


                  </div>


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
<div *ngIf='IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title"> Detail Info</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <detail-grid *ngIf="CurrentActorEducationInfoControllerByCode"
                             [columns]="dcolumns" [data]="CurrentActorEducationInfoControllerByCode">

                </detail-grid>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
